import React from 'react';
import { useNavigate } from 'react-router-dom';
import './css/Daily.css';

const About = () => {
    const navigate = useNavigate();

    return (
        <div className="wrapper supportScreen">
            <div className="supportSurface">
                <div className="supportHeader">
                    <h2 className="dailyMainTitle">
                        Get your data to <br />
                        work for you
                    </h2>
                    <p className="inDevelopmentCopy">
                        Learn how Trampoline Health fits into your routine, and read our legal documents when they are ready.
                    </p>
                </div>

                <div className="supportSectionCard">
                    <h5 className="supportSectionTitle">About</h5>
                    <div className="homeBttnContainer supportActions">
                        <button
                            type="button"
                            className="homeBttn"
                            onClick={() => navigate('/in-development')}
                        >
                            Learn more
                        </button>
                        <button
                            type="button"
                            className="homeBttn"
                            onClick={() => navigate('/in-development')}
                        >
                            Terms of Service
                        </button>
                        <button
                            type="button"
                            className="homeBttn"
                            onClick={() => navigate('/in-development')}
                        >
                            Privacy Policy
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
